import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useFeatureFlag } from '../../FeatureFlags';
import ComplianceCenterLegacy from '../Dashboard/ComplianceCenter';
import ComplianceCenterRedesign from './ComplianceCenterRedesign';
import RegulationPage from './RegulationPage/RegulationPage';
import { ComplianceFilterProvider } from './ComplianceFilterContext';

// AB#17116 AC1a: the ComplianceCenter feature flag is resolved once here, for the
// Compliance Center as a whole — both compositions render at the existing route.
// Any later redesign route (regulation drill-downs) must nest under this component
// so it reads the same resolved value and stays unreachable when the flag is off.
const ComplianceCenterRoot = (props) => {
    const redesignEnabled = useFeatureFlag('ComplianceCenter');

    if (!redesignEnabled) {
        // AB#17128 AC1: drill-down routes are unreachable with the flag off
        return (
            <Switch>
                <Route exact path="/ComplianceCenter" render={() => <ComplianceCenterLegacy {...props} />} />
                <Redirect to="/ComplianceCenter" />
            </Switch>
        );
    }

    // AB#17128: the filter provider stays mounted across landing and drill-down, so the page-level filter carries both ways
    return (
        <ComplianceFilterProvider>
            <Switch>
                <Route exact path="/ComplianceCenter" render={() => <ComplianceCenterRedesign {...props} />} />
                <Route path="/ComplianceCenter/:regulation" component={RegulationPage} />
            </Switch>
        </ComplianceFilterProvider>
    );
};

export default ComplianceCenterRoot;
